import React from 'react'
import { DeleteOutline, Edit, MoreVert, Print } from '@material-ui/icons'
import Icon from '../../Icon'
import { doOptionalAction } from '../action/OptionalAction'

export const createRowActionHelper = ({
  isReadOnly,
  propTable,
  propAction,
  displayPrintMenu,
  displayTableMenu,
  setDataRowSelected,
  setShowPrintButton,
  setPrintOption,
  checkHiddenAction,
  checkLockAction,
  onRowDefaultAction,
}) => {
  const createPrintRowAction = (item) => (rowData) => {
    let action = {
      icon: Print,
      position: 'row',
      onClick: async (event, rowData) => {
        displayPrintMenu(event)
        setDataRowSelected(rowData)
      },
      hidden: checkHiddenAction(item, 'actionPrint', rowData),
      disabled: checkLockAction(item, 'actionPrint', rowData),
    }
    return action
  }

  const appendPrintAction = (item, rowTableAction, option = {}) => {
    const { printList = [] } = item
    const { prepend = false } = option
    setShowPrintButton({ show: item.isActive, action: item })
    let printPerRowOption = printList.filter((item) => item.printPerRow)
    setPrintOption(printPerRowOption)
    if (item.isActive && printPerRowOption.length > 0) {
      let printAction = createPrintRowAction(item)
      if (prepend) {
        return [printAction].concat(rowTableAction)
      }
      rowTableAction.push(printAction)
    }
    return rowTableAction
  }

  const createEditRowAction = (item) => (rowData) => {
    let action = {
      icon: Edit,
      position: 'row',
      tooltip: 'แก้ไข',
      onClick: (event, rowData) => onRowDefaultAction(item, rowData),
      hidden: checkHiddenAction(item, 'actionEdit', rowData),
      disabled: checkLockAction(item, 'actionEdit', rowData),
    }
    return action
  }

  const createDeleteRowAction = (item) => (rowData) => {
    let action = {
      icon: DeleteOutline,
      position: 'row',
      tooltip: 'Delete',
      onClick: (event, rowData) => onRowDefaultAction(item, rowData, true),
      hidden: checkHiddenAction(item, 'actionDelete', rowData),
      disabled: checkLockAction(item, 'actionDelete', rowData),
    }
    return action
  }

  const createMoreMenuAction = () => (rowData) => {
    let action = {
      icon: MoreVert,
      tooltip: 'Menu',
      position: 'row',
      onClick: async (event, rowData) => {
        displayTableMenu(event)
        setDataRowSelected(rowData)
      },
    }
    return action
  }

  const createShowIconAction = (item) => (rowData) => {
    let isLock = checkLockAction(item, 'actionIcon', rowData)
    let tooltip = isLock ? {} : { tooltip: item.name }
    return {
      ...tooltip,
      icon: () => (
        <span
          style={{
            color: isLock ? 'gray' : item?.iconColor || '#000',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <Icon iconName={item.icon} size="22" />
        </span>
      ),
      onClick: async (event, rowData) =>
        doOptionalAction(item, rowData, { ...propTable, propAction }),
      hidden: checkHiddenAction(item, 'actionIcon', rowData),
      disabled: checkLockAction(item, 'actionIcon', rowData),
    }
  }

  const applyOptionalActions = (column, rowTableAction) => {
    let optional = column.optional || []
    let moreIconAction = optional.filter(
      (item) => item?.actionType !== 'showIcon',
    )
    let showIconAction = optional.filter(
      (item) => item?.actionType === 'showIcon',
    )

    if (showIconAction.length > 0) {
      if (!isReadOnly) {
        let otherAction = []
        showIconAction.forEach((item) => {
          otherAction.push(createShowIconAction(item))
        })
        rowTableAction = otherAction.concat(rowTableAction)
      }
    }
    if (moreIconAction.length > 0) {
      if (!isReadOnly) {
        let otherAction = [createMoreMenuAction()]
        rowTableAction = otherAction.concat(rowTableAction)
      }
    }
    return rowTableAction
  }

  return {
    createPrintRowAction,
    appendPrintAction,
    createEditRowAction,
    createDeleteRowAction,
    createMoreMenuAction,
    createShowIconAction,
    applyOptionalActions,
  }
}
